<div class="discount-rejection-coupon-conditions">
  <pdq-card variant="popover" color="white">
    <div class="card-header">
      <pdq-heading element="h5">Display Conditions</pdq-heading>
      <span class="subtitle body-13-regular">This extension will only appear if:</span>
    </div>
    <pdq-divider></pdq-divider>

    <div class="card-content">
      <pdq-rules-dynamic-form
        [formGroup]="formGroup"
        formArrayFieldName="displayRules"
        [rules]="displayRules | addCurrencyOption: shopCurrencySymbol"
        [entities]="displayRulesEntities"
        [shopCurrencySymbol]="shopCurrencySymbol"
        [versionWithOrOperator]="true"></pdq-rules-dynamic-form>
    </div>
  </pdq-card>

  <pdq-card variant="popover" color="white" [formGroup]="thresholdFormGroup">
    <div class="threshold-header">
      <div class="threshold-header-text">
        <pdq-heading element="h5">Failed Attempt Threshold</pdq-heading>
        <span class="subtitle body-12-regular"
          >Only show this extension after a customer has entered an invalid coupon code a set number of times.</span
        >
      </div>
      <pdq-slide-toggle formControlName="enabled" togglePosition="right"></pdq-slide-toggle>
    </div>
    <pdq-divider></pdq-divider>

    <div class="card-content">
      <div class="threshold-settings" [class.disabled]="!thresholdFormGroup.get('enabled')?.value">
        <div class="threshold-attempts">
          <span class="body-14-regular">Attempts</span>
          <pdq-input-arrows
            [control]="attemptsControl"
            [min]="minAttempts"
            [max]="maxAttempts"
            [disabled]="!thresholdFormGroup.get('enabled')?.value"
            class="attempts-input"></pdq-input-arrows>
          <span class="body-14-regular">tries</span>
        </div>

        <pdq-checkbox
          formControlName="limitWithinTimeWindow"
          label="Limit attempts within a time window"></pdq-checkbox>

        <div class="time-window-settings" [class.disabled]="isTimeWindowDisabled">
          <span class="body-14-regular time-window-label">Time window</span>
          <pdq-input-arrows
            [control]="timeWindowValueControl"
            [min]="timeWindowMinValue"
            [max]="timeWindowMaxValue"
            [disabled]="isTimeWindowDisabled"
            class="time-window-input">
          </pdq-input-arrows>
          <pdq-dropdown
            formControlName="timeWindowUnit"
            [options]="timeWindowUnitOptions"
            [disabled]="isTimeWindowDisabled"
            class="time-window-unit">
          </pdq-dropdown>
        </div>

        <span class="body-12-regular threshold-summary">{{ thresholdSummaryText }}</span>
      </div>
    </div>
  </pdq-card>
</div>
